import { Col, Row } from 'antd';

import SearchItemCard from '../../Atoms/SearchItemCard';
import Styles from './SearchItem.module.scss';
import { TSearchItem } from './definitions';

export default function SearchItem({
  data,
  afterClick,
  highlightText,
}: TSearchItem) {
  if (!data) {
    return <div />;
  }

  if (data.length === 0) {
    return <div />;
  }

  return (
    <Row className={Styles['search-item']}>
      <Col>
        <Row
          align="middle"
          gutter={[15, 14]}
          className={Styles['search-item-row']}
        >
          {data.map((item, index) => {
            return (
              <Col key={index} span={6} className={Styles['search-item-col']}>
                <SearchItemCard
                  name={item?.name ?? ''}
                  image={item.image}
                  brand={item.brand}
                  category={item.category}
                  slug={item.slug}
                  afterClick={afterClick}
                  highlightText={highlightText}
                />
              </Col>
            );
          })}
        </Row>
      </Col>
    </Row>
  );
}
